import React from 'react'

const ContactDash = ({setShowDash}) => {
    return (
        <div>
            <div className='mt-4'>
                <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide">Create new message</h2>
                <div>
                    {/* here  */}
                </div>
                <button
                    type="button"
                    className="mt-2 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    onClick={() => setShowDash(false) }
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default ContactDash
